<template>
  <div>
    <label class="field_label">{{ current_champ.label }} {{ is_ffa ? " FFA" : "" }} {{ is_ffrp ? "FFRP" : "" }}<span
        class="text-red" v-if="current_champ.mandatory == 1">*</span></label>
    <v-text-field v-model="current_champ.value" ref="field" @blur="$refs.field.validate()"
      :disabled="current_champ.disabled || is_disable"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode, is_ffa, is_ffrp)]"></v-text-field>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
export default {
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      current_champ: {},
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),

    is_ffrp() {
      return this.mainStore.module.is_ffrp_event;
    },
    is_ffa() {
      if (!this.inscription.coureur.champs.type_document) {
        return false;
      }
      return this.inscription.coureur.champs.type_document.value == "Licence FFA";
    },
  },

  watch: {
    champ: {
      deep: true,
      handler() {
        this.debouncedWatchHandler();
      },
    },

    "inscription.coureur.champs.nom": {
      deep: true,
      handler() {
        this.debouncedWatchHandler();
      },
    },
    "inscription.coureur.champs.prenom": {
      deep: true,
      handler() {
        this.debouncedWatchHandler();
      },
    },
    "inscription.coureur.champs.sexe": {
      deep: true,
      handler() {
        this.debouncedWatchHandler();
      },
    },
    "inscription.coureur.champs.date_naissance": {
      deep: true,
      handler() {
        this.debouncedWatchHandler();
      },
    },
  },
  methods: {
    isPeriodeRenouvellementLicence(message) {
      const date_debut_evenement = this.$moment(this.mainStore.module.evenement.date_debut);
      const annee_courante = this.$moment().year();
      const first_september = this.$moment(`${annee_courante}-09-01`);
      const is_renouvellement = message.includes("PROx006");

      return is_renouvellement && this.$moment().isBefore(first_september) && date_debut_evenement.isAfter(first_september);
    },
    debouncedWatchHandler() {
      if (this._watchDebounceTimer) {
        clearTimeout(this._watchDebounceTimer);
      }
      this._watchDebounceTimer = setTimeout(async () => {
        this._watchDebounceTimer = null;

        this.current_champ = this.champ;
        await this.fetch_ffa_webservice();
        this.bookingStore.refreshAllCoursesCarts();
        this.$forceUpdate();
      }, 500);
    },
    async fetch_ffa_webservice() {

      // si le format de la licence est incorrect, on ne fait pas la requête
      if (!this.current_champ.is_valid_num_ffa() && this.current_champ.value != '' && this.current_champ.value != null) {
        return;
      }

      this.inscription.coureur.unvalidate_document();
      let disable_webservice = this.mainStore.module.disable_webservice_ffa;
      let num_ffa = this.mainStore.module.ffa_num_competition;

      if (disable_webservice || !num_ffa || num_ffa == "" || !this.is_ffa) {
        return;
      }
      const date_debut_evenement = this.$moment(this.mainStore.module.evenement.date_debut);
      const annee_debut_evenement = this.$moment(date_debut_evenement).year();
      const first_september_of_annee_debut_evenement = this.$moment(`${annee_debut_evenement}-09-01`);
      if (this.$moment().isBefore(first_september_of_annee_debut_evenement) && date_debut_evenement.isAfter(first_september_of_annee_debut_evenement)) {
        return;
      }

      if (!this.inscription.coureur.has_all_required_fields_for_webservice()) {
        return;
      }

      let response = await this.inscription.coureur.try_fetch_ffa_webservice(num_ffa);
      if (response[0]) {
        this.$emit("licence_validated");
      } else if (this.isPeriodeRenouvellementLicence(response[1])) {
        this.mainStore.notification.send("Votre n° de licence est reconnu, mais n'est pas encore valide pour cet événement. Pensez à renouveler votre licence.", "info", 6000);
      }
      else {
        this.mainStore.notification.send("Une erreur est survenue lors de la vérification de votre licence FFA", "error", 6000);
        this.current_champ.value = "";
      }
    },
  },
  created() {
    this.current_champ = this.champ;
  },
  beforeUnmount() {
    if (this._watchDebounceTimer) {
      clearTimeout(this._watchDebounceTimer);
    }
  },
};
</script>

<style lang="scss" scoped></style>